import EditTemplateModal from "./EditTemplateModal";

export default EditTemplateModal;
